<!-- <app-progress-bar></app-progress-bar> -->
<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <app-toolbar (toggleMenu)="toggleSidenav()"></app-toolbar>
    <mat-sidenav-container class="example-sidenav-container">
        <mat-sidenav
            #snav
            [opened]="!mobileQuery.matches"
            (openedStart)="!mobileQuery.matches ? openedStart() : null"
            (closedStart)="mobileQuery.matches ? closedStart() : null"
            [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches"
            [fixedTopGap]="mobileTopGapQuery.matches ? topGapMobile : topGapLarge"
        >
            <!-- <app-sidebar-user-area></app-sidebar-user-area> -->
            <app-navbar [sidenav]="snav" [hideMiniButton]="mobileQuery.matches"></app-navbar>
        </mat-sidenav>

        <mat-sidenav-content
            [@onMainContentChange]="
            mainContentChange && onSideNavChange
                ? 'open'
                : snav.mode === 'over'
                ? 'collapse'
                : 'close'
            "
        >
            <main>
                <!-- <app-page-header [pageTitle]="pageTitle"></app-page-header> -->
                <router-outlet></router-outlet>
            </main>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>